<template>
    <div :class="$t('exam_course.exam_course_apprentice_simple_card')">
        <div class="row">
            <div class="col-12">
                <b-row>
                    <b-col
                        class="sector"
                        cols="12"
                        md="3">
                        <!--                        todo zelfde ids-->
                        <label
                            class="examsector-group"
                            for="sector-select"
                            >{{ $t('exam_course.level') }}</label
                        >
                        <!--                        todo listener so we can reset others-->
                        <!--                        todo disabled-->
                        <b-form-select
                            class="apprentice-primary-select sectorselect"
                            id="sector-select"
                            @change="onChangeSelectedEducationLevel"
                            :value="selectedEducationLevel"
                            :options="educationLevelsData"
                            size="sm"></b-form-select>
                    </b-col>
                    <b-col
                        class="course"
                        cols="12"
                        md="3">
                        <label
                            class="examcourse-group"
                            for="course-select"
                            >{{ $t('exam_course.courses') }}</label
                        >
                        <b-form-select
                            class="apprentice-primary-select courseselect"
                            id="course-select"
                            @change="onChangeSelectedCourse"
                            :value="selectedCourse"
                            :options="courseData"
                            size="sm"
                            :disabled="!selectedEducationLevel"></b-form-select>
                    </b-col>
                    <b-col
                        class="year"
                        cols="12"
                        md="3">
                        <label
                            class="examyear-group"
                            for="year-select"
                            >{{ $t('exam_course.year') }}</label
                        >
                        <b-form-select
                            class="apprentice-primary-select yearselect"
                            id="year-select"
                            @change="onChangeSelectedYear"
                            :value="selectedYear"
                            :options="yearData"
                            size="sm"
                            :disabled="!selectedCourse"></b-form-select>
                    </b-col>
                    <b-col
                        class="period"
                        cols="12"
                        md="3">
                        <label
                            class="examperiod-group"
                            for="period-select"
                            >{{ $t('exam_course.period_courses') }}</label
                        >
                        <b-form-select
                            class="apprentice-primary-select periodselect"
                            id="period-select"
                            v-model="selectedPeriod"
                            :options="periodData"
                            size="sm"
                            :disabled="!selectedYear"></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="row">
            <div
                class="col-12 header"
                v-if="selectedEducationLevel && selectedCourse && selectedYear">
                <h2>{{ examTitle }}</h2>
            </div>

            <div class="col-12 col-md-6">
                <div
                    class="exam-curriculum"
                    v-if="examCurriculum">
                    <div class="component-title">
                        <h5 class="title">{{ $t('exam_course.exam_material') }}</h5>
                    </div>

                    <div
                        class="curriculum-item"
                        v-for="curriculum of examCurriculum"
                        :key="curriculum.id">
                        <div
                            class="icon"
                            @click="viewFile({ curriculum })">
                            <i class="far fa-file-pdf"></i>
                        </div>
                        <div class="title">
                            {{ curriculum.name }}
                            <b-badge
                                class="d-none"
                                variant="info preview-badge d-none"
                                :class="{ 'd-inline': curriculum.id === selectedFile }"
                                >Live preview
                            </b-badge>
                        </div>
                        <div class="download-link">
                            <a
                                class="curriculum-download"
                                :href="curriculum.path"
                                download>
                                <i class="btn-download"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div
                    class="exam-curriculum"
                    v-if="examFiles">
                    <div class="component-title">
                        <h5 class="title">{{ $t('exam_course.exam_documents') }}</h5>
                    </div>

                    <div
                        class="exam-files-item"
                        v-for="file of examFiles"
                        :key="file.id">
                        <div
                            class="icon"
                            @click="viewFile({ file })">
                            <i class="far fa-file-pdf"></i>
                        </div>
                        <div class="title">
                            {{ file.name }}
                            <b-badge
                                class="d-none"
                                variant="info preview-badge d-none"
                                :class="{ 'd-inline': file.id === selectedFile }"
                                >Live preview
                            </b-badge>
                        </div>
                        <div class="download-link">
                            <a
                                class="curriculum-download"
                                :href="file.path"
                                download>
                                <i class="btn-download"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row d-none d-sm-flex">
            <div class="col-12">
                <div
                    class="examviewer"
                    id="examviewer"
                    ref="previewer"></div>
            </div>
        </div>
    </div>
</template>

<script>
import PDFObject from 'pdfobject';

export default {
    name: 'design-2021-examenvakken',
    props: ['educationLevelsIn'],
    data() {
        return {
            selectedYear: null,
            selectedEducationLevel: null,
            selectedCourse: null,
            selectedPeriod: null,

            educationLevelsData: this.educationLevelsIn.map((level) => {
                return {
                    value: level.data.id,
                    text: level.data.name,
                };
            }),

            filtered: {},
            availableExamCurriculum: [],
            availableExamDocuments: [],
            pdfEmbedUrl: '',
            pdfOptions: {
                pdfOpenParams: {
                    width: '100%',
                    height: '500px',
                },
            },
            previewedCurriculum: {},
            previewedExamFile: {},

            selectedFile: null,
        };
    },
    computed: {
        courseData() {
            if (!this.selectedEducationLevel) {
                return [];
            }

            let sector = null;

            for (const s of this.educationLevelsIn) {
                if (s.data.id === this.selectedEducationLevel) {
                    sector = s;
                    break;
                }
            }

            if (!sector) {
                return [];
            }

            return sector.courses.map((course) => {
                return {
                    value: course.data.id,
                    text: course.data.pretty_name,
                };
            });
        },
        yearData() {
            if (!this.selectedCourse) {
                return [];
            }

            let course = null;
            for (const s of this.educationLevelsIn) {
                for (const c of s.courses) {
                    if (c.data.id === this.selectedCourse && s.data.id === this.selectedEducationLevel) {
                        course = c;
                        break;
                    }
                }
            }

            return course.years.map((year) => {
                return {
                    value: year.data.id,
                    text: year.data.year,
                };
            });
        },

        periodData() {
            if (!this.selectedYear) {
                return [];
            }

            // todo sounds weird
            let years = null;
            for (const s of this.educationLevelsIn) {
                for (const c of s.courses) {
                    for (const y of c.years) {
                        if (y.data.id === this.selectedYear) {
                            years = y;
                            break;
                        }
                    }
                }
            }

            let year = [];
            // todo how does this work
            years.files.filter((period) => {
                if (year.length === 0 && period.period !== null) {
                    year.push(period.period);
                } else if (year.findIndex((y) => y === period.period) && period.period !== null) {
                    year.push(period.period);
                }
            });

            year = year.filter((y, yearIndex, a) => a.indexOf(y) == yearIndex);

            return year.map((y) => {
                return {
                    value: y,
                    text: y,
                };
            });
        },

        examFiles() {
            if (this.selectedEducationLevel && this.selectedCourse && this.selectedYear && this.selectedPeriod) {
                let sector = null;
                let courses = null;
                let examDocuments = null;
                for (const s of this.educationLevelsIn) {
                    if (s.data.id === this.selectedEducationLevel) {
                        sector = s;
                        for (const c of sector.courses) {
                            if (c.data.id === this.selectedCourse) {
                                courses = c;
                                for (const y of courses.years) {
                                    if (y.data.id === this.selectedYear) {
                                        examDocuments = y;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

                if (examDocuments !== null) {
                    return examDocuments.files
                        .filter((examFile) => examFile.period !== null && examFile.period == this.selectedPeriod)
                        .map((eF) => {
                            // todo why map?
                            return {
                                id: eF.file_id,
                                name: eF.name,
                                extension: eF.file.extension,
                                fullName: eF.file.full_name,
                                path: eF.file.path,
                                type: eF.type.name,
                                active: false,
                            };
                        });
                } else {
                    examDocuments = null;
                    return null;
                }
            }
        },

        examCurriculum() {
            if (!this.selectedPeriod) {
                return null;
            }

            let sector = null;
            let courses = null;
            let examDocuments = null;
            for (const s of this.educationLevelsIn) {
                if (s.data.id === this.selectedEducationLevel) {
                    sector = s;
                    for (const c of sector.courses) {
                        if (c.data.id === this.selectedCourse) {
                            courses = c;
                            for (const y of courses.years) {
                                if (y.data.id === this.selectedYear) {
                                    examDocuments = y;
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            if (examDocuments !== null) {
                return examDocuments.files
                    .filter((examFile) => examFile.period === null)
                    .map((eF) => {
                        return {
                            id: eF.file_id,
                            name: eF.name,
                            extension: eF.file.extension,
                            fullName: eF.file.full_name,
                            path: eF.file.path,
                            type: eF.type.name,
                            active: false,
                        };
                    });
            } else {
                examDocuments = null;
                return null;
            }
        },

        examTitle() {
            // todo good but better select model
            let sector = null;
            let sectorName = null;
            let courses = null;
            let coursesName = null;
            let year = null;
            for (const s of this.educationLevelsIn) {
                if (s.data.id === this.selectedEducationLevel) {
                    sector = s;
                    sectorName = s.data.name;
                    for (const c of sector.courses) {
                        if (c.data.id === this.selectedCourse) {
                            courses = c;
                            coursesName = c.data.name;
                            for (const y of courses.years) {
                                if (y.data.id === this.selectedYear) {
                                    year = y.data.year;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            if (coursesName !== null && sectorName !== null && year !== null && this.selectedPeriod !== null) {
                return `${coursesName} ${sectorName} ${year} (${this.$t('exam_course.period_course')}) ${this.selectedPeriod}`;
            }
        },

        getPreviewedExamFile() {
            return !!this.previewedCurriculum;
        },
    },
    methods: {
        getPreviewedCurriculum(curriculum) {
            if (this.previewedCurriculum) {
                return curriculum.id === this.previewedCurriculum.id;
            }
            return false;
        },

        scrollToElement(element) {
            const source = this.$el.getElementsByClassName(element)[0];

            if (source) {
                source.scrollIntoView({ behavior: 'smooth' });
            }
        },

        viewFile(fieldData) {
            const data = fieldData.file ? fieldData.file : fieldData.curriculum; // todo should be 1 standard

            this.selectedFile = data.id;

            if (PDFObject.supportsPDFs) {
                // this.pdfEmbedUrl =`/docs/${fieldData.data.item.name}.pdf`; todo
                this.pdfEmbedUrl = data.path;

                if (data.type === this.$t('exam_course.exam_material')) {
                    this.previewedCurriculum.id = data.id;
                    this.previewedExamFile = {};
                }

                if (data.type === this.$t('exam_course.answer_sheet')) {
                    this.previewedExamFile.id = data.id;
                    this.previewedCurriculum = {};
                }

                PDFObject.embed(this.pdfEmbedUrl, '.examviewer', this.pdfOptions);
                this.scrollToElement('examviewer');
            } else {
                this.alert.notice(
                    this.$t('exam_course.warning'),
                    this.$t('exam_course.the_browser_does_not_support_a_built_in_pdf_viewer_download_file_to_view'),
                );
            }
        },
        onChangeSelectedEducationLevel(value) {
            this.selectedEducationLevel = value;
            this.selectedCourse = null; // todo could check if course is also in the other education level
            this.selectedYear = null;
            this.selectedPeriod = null;
        },
        onChangeSelectedCourse(value) {
            this.selectedCourse = value;
            this.selectedYear = null;
            this.selectedPeriod = null;
        },
        onChangeSelectedYear(value) {
            this.selectedYear = value;
            this.selectedPeriod = 1; // todo schould check if 1 is really there although that should always be the case
        },
    },
};
</script>

<style scoped lang="scss">
.examenvakken {
    select {
        margin-bottom: 0;
    }
}

.exam-curriculum-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.curriculum-item,
.exam-files-item {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    font-size: 1.3125rem;
    margin-bottom: map-get($grid-gutter-spacing, 'eight');
    padding-bottom: map-get($grid-gutter-spacing, 'eight');

    .icon {
        align-self: center;
        padding: 10px;
        background: $secondary-background-color;
        border-radius: $border-radius-content;
        color: $primary;

        &:hover {
            cursor: pointer;
        }
    }

    .title {
        font-size: $default-font-size;
        font-family: $headings-font-family;
        margin-left: map-get($grid-gutter-spacing, 'ten');
        align-self: center;
        word-break: break-word;
    }

    .download-link {
        align-self: center;
        margin-left: auto;

        i {
            font-style: normal;
        }
    }

    &:not(:last-child) {
        border-bottom: 3px dotted $border-color;
    }
}

.btn-link:before,
.btn-link:after {
    display: none;
}

.sector,
.course,
.year,
.period {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.examsector-group,
.examcourse-group,
.examyear-group,
.examperiod-group {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 0;
    padding-bottom: 5px;
}

.sectorselect,
.courseselect,
.yearselect,
.periodselect {
    margin-top: 0;
}

.header {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.preview-badge {
    font-size: 0.625rem;
    border-radius: $border-radius-content;
    font-weight: $font-weight-bold;
    letter-spacing: 0.5px;
    margin-left: map-get($grid-gutter-spacing, 'fifteen');
    color: $white;
    background-color: $success;
}

.examviewer:not(:empty) {
    min-height: 600px;
    height: 100%;
}
</style>
